export default "__VITE_ASSET__D34_Y6UX__"